module.exports = __webpack_public_path__ + "static/media/18.f611cef8.jpg";